import {
  Box,
  Center,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Image,
  Text,
  useMediaQuery,
} from '@chakra-ui/react'
import ArrowIcon from '@assets/svgs/learn/arrow_right_7.svg'
import SnailIcon from '@assets/svgs/snail.svg'
import VolumeIcon from '@assets/svgs/learn/volume_2.svg'
import useVocabulary from './useVocabulary'
import learnRequest from '@apis/learn'
import {useEffect, useState} from 'react'
import GlobalMic3 from '@components/GlobalMic3'

const Pronounce = ({
  currentVocabulary,
  setCurrentIndexQuestion,
}: {
  currentVocabulary: any
  setCurrentIndexQuestion: any
}) => {
  const [isLargerThan1280] = useMediaQuery('(min-width: 1600px)')
  const {handlePlayAudio, handlePauseAudio} = useVocabulary()
  const [speechData, setSpeechData] = useState<any>()
  const [isDisable, setIsDisable] = useState<any>(false)
  const [totalCheck, setTotalCheck] = useState(0)
  const [isRecording, setIsRecording] = useState(false)

  useEffect(() => {
    if (!currentVocabulary?.vocabularyQuestionData?.audio) return

    const audioTimer = setTimeout(() => {
      handlePlayAudio(currentVocabulary.vocabularyQuestionData.audio)
    }, 1000)

    return () => {
      clearTimeout(audioTimer)
      handlePauseAudio()
    }
  }, [currentVocabulary])

  useEffect(() => {
    if (!speechData?.audio_url) return

    const audioTimer = setTimeout(() => {
      handlePlayAudio(speechData.audio_url)
    }, 200)

    return () => clearTimeout(audioTimer)
  }, [speechData])

  const handleClickBtn = () => {
    setCurrentIndexQuestion((pre: any) => pre + 1)
    handlePauseAudio()
  }

  const handleStartRecording = () => {
    handlePauseAudio()
    setIsDisable(true)
    setIsRecording(true)
  }

  const handleRecordingComplete = async (blob: any) => {
    let file = new File([blob], 'audio.wav', {type: 'audio/wav'})
    const formData = new FormData()
    formData.append('audio-file', file)
    formData.append(
      'text-refs',
      currentVocabulary?.vocabularyQuestionData.textEn,
    )
    const res = await learnRequest.getSpeechCheck(formData)
    setTotalCheck((pre: any) => pre + 1)
    if (res.status === 200) {
      setSpeechData(res.data.data)
    }
    setIsDisable(false)
    setIsRecording(false)
  }

  const getColorByScore = (score: any) => {
    if (score >= 75) return '#45BB66'
    if (score >= 50) return '#FFCD00'
    if (score >= 0) return '#E55856'
    return '#BFBFBF40'
  }

  return (
    <Box>
      <Center flexDirection={'column'}>
        <Text fontSize={'18px'} textTransform={'uppercase'} color={'#1890FF'}>
          {currentVocabulary?.vocabularyQuestionData.title}
        </Text>
        <CircularProgress
          mt={isLargerThan1280 ? '32px' : '16px'}
          value={Math.floor(speechData?.total_score * 100) || 0}
          color={getColorByScore(speechData?.total_score * 100)}
          size={isLargerThan1280 ? '128px' : '100'}
          thickness="4px">
          <CircularProgressLabel
            fontSize={isLargerThan1280 ? '64px' : '48px'}
            fontWeight={600}
            color={getColorByScore(speechData?.total_score * 100)}>
            {speechData ? Math.floor(speechData?.total_score * 100) : 0 || '--'}
          </CircularProgressLabel>
        </CircularProgress>
        <Flex my={isLargerThan1280 ? '16px' : '8px'} gap={'12px'}>
          <Center
            opacity={isDisable ? 0.5 : 1}
            pointerEvents={isDisable ? 'none' : 'unset'}
            cursor={'pointer'}
            h={isLargerThan1280 ? '64px' : '54px'}
            w={'96px'}
            borderRadius={'24px'}
            bg={'rgba(236, 239, 241, 0.50)'}
            onClick={() =>
              handlePlayAudio(currentVocabulary?.vocabularyQuestionData.audio)
            }>
            <Image src={VolumeIcon} />
          </Center>
          <Center
            opacity={isDisable ? 0.5 : 1}
            pointerEvents={isDisable ? 'none' : 'unset'}
            cursor={'pointer'}
            h={isLargerThan1280 ? '64px' : '54px'}
            w={'96px'}
            borderRadius={'24px'}
            bg={'rgba(236, 239, 241, 0.50)'}
            onClick={() =>
              handlePlayAudio(
                currentVocabulary?.vocabularyQuestionData.audio,
                0.5,
              )
            }>
            <Image src={SnailIcon} />
          </Center>
        </Flex>
        <Text fontSize={'24px'} fontWeight={600} color={'#263238'}>
          {speechData?.result ? (
            <>
              {speechData?.result.map((item: any, index: any) => (
                <Text key={index} as={'span'} pr={'4px'}>
                  {item?.letters.map((letter: any, index: any) => (
                    <Text
                      key={index}
                      as={'span'}
                      color={getColorByScore(Math.floor(letter.score * 100))}>
                      {letter.letter}
                    </Text>
                  ))}
                </Text>
              ))}
            </>
          ) : (
            currentVocabulary?.vocabularyQuestionData.textEn
          )}
        </Text>
        <Text
          fontSize={'18px'}
          color={'#546E7A'}
          mt={isLargerThan1280 ? '8px' : '4px'}>
          {currentVocabulary?.vocabularyQuestionData.ipa}
        </Text>
        <Text
          fontSize={'18px'}
          color={'#263238'}
          mt={isLargerThan1280 ? '8px' : '4px'}>
          {currentVocabulary?.vocabularyQuestionData.textVi}
        </Text>
        <Box h={'40px'} my={isLargerThan1280 ? '16px' : '8px'}>
          {(speechData || isRecording) && (
            <Flex
              p={'8px 16px'}
              bg={
                !isRecording
                  ? speechData?.total_score * 100 >= 50
                    ? speechData?.total_score * 100 >= 60
                      ? '#71D78B'
                      : '#FFCD00'
                    : '#E55856'
                  : 'orange'
              }
              borderRadius={'37px'}>
              <Text fontSize={'16px'} fontWeight={600} color={'white'}>
                {!isRecording
                  ? speechData?.total_score * 100 >= 50
                    ? speechData?.total_score * 100 >= 60
                      ? 'Chính xác!'
                      : 'Cố lên nhé, sắp chính xác rồi!'
                    : 'Cố lên nhé, sắp chính xác rồi'
                  : 'Đang thu...'}
              </Text>
            </Flex>
          )}
        </Box>
        <Flex
          gap={{base: '16px', md: '40px'}}
          alignItems={'center'}
          px={'12px'}>
          <Box w={{base: '90px', md: '162px'}} />
          <GlobalMic3
            handleStartRecording={handleStartRecording}
            handleRecordingComplete={handleRecordingComplete}
          />
          <Box w={{base: '90px', md: '162px'}}>
            {(speechData?.total_score * 100 >= 60 || totalCheck >= 2) && (
              <Center
                cursor={'pointer'}
                gap={'12px'}
                alignItems={'center'}
                bg={'#F5F5F5'}
                borderRadius={'100px'}
                h={'50px'}
                onClick={handleClickBtn}>
                <Text
                  fontSize={'16px'}
                  fontWeight={700}
                  color={'#263238'}
                  flexShrink={0}>
                  Tiếp tục
                </Text>
                <Image src={ArrowIcon} display={{base: 'none', md: 'block'}} />
              </Center>
            )}
          </Box>
        </Flex>
      </Center>
    </Box>
  )
}

export default Pronounce
